import ExpandableCard from "../Common/ExpandableCard"
import { useState } from "react"
import disclaimer from "../../Configs/JSON/disclaimer.json"
import "./Disclaimer.less"
import { DataLayerFn } from "../../Configs/API"
import FormStore from "../../Configs/Store/forms"

const Disclaimer = ({ data }) => {
  const [selected, setselected] = useState(null)
  var subSection = FormStore.quoteScreen === true ? "Calculator-Quotescreen" : "Calculator-Landing page"
  function callDataLayer() {
    if (selected) {
      var subSection = FormStore.quoteScreen === true ? "Calculator-Quotescreen" : "Calculator-Landing page"
      DataLayerFn(`Disclaimer_Selected|| ${subSection} | Disclaimer`, FormStore, "", "", "", "")
      setselected(false)
    } else {
      setselected(true)
    }
  }

  return (
    <div className="Disclaimer_Root" onClick={callDataLayer}>
      <div className="DiscDivider" />
      <ExpandableCard dataType={data} componentName={"Disclaimer"} open={false} from={"Disclaimer"} dataSet={disclaimer} />
    </div>
  )
}

export default Disclaimer
